<template>
  <div class="accordion__body-nav--wrapper">
    <div class="title">
      Применяется на участках
    </div>
    <div class="items">
      <swiper :options="swiperOption" ref="mySwiper">
        <router-link
          :to="`/details/${n}/`"
          class="accordion__links-item swiper-slide"
          v-for="n in indices"
          :key="n">
          <div class="content">
            <div class="content__img">
              <Figure :defaultSvgParams="defaultSvgParams"
                      :isNav="true"
                      :navId="n"/>
            </div>
            <div class="content__info">
              <div class="content__info-size">
                {{sectors[n].sideL}} x {{sectors[n].sideB}} м
              </div>
              <div class="content__info-count">x{{ sectors[n].sectorsCount }}</div>
            </div>
          </div>
          <div class="overlay"><b>Смотреть расчет</b></div>
        </router-link>
        <div class="swiper-scrollbar" slot="scrollbar"></div>
      </swiper>
      <!--<div class="div" v-for="n in indices" :key="n">
        {{ sectors[n] }}
      </div>-->
    </div>
  </div>
</template>
<script>

import { mapState } from 'vuex';
import Figure from '@/components/Figure.vue';

export default {
  props: {
    indices: Array,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 5.5,
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: false,
        },
        breakpoints: {
          767: {
            slidesPerView: 4.5,
          },
          575: {
            slidesPerView: 3,
          },
          359: {
            slidesPerView: 2,
          },
        },
      },
    };
  },
  components: {
    Figure,
  },
  methods: {
  },
  computed: {
    ...mapState({
      sectors: state => state.sectors,
      defaultSvgParams: state => state.defaultSvgParams,
    }),
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    sectorId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    sectorFromState() {
      return this.$store.getters.getSector(this.sectorId);
    },
  },
};
</script>
<style lang="sass">
  .accordion
    &__body
      &-nav
        &--wrapper
          background: #FFFFFF
          border-radius: 0 0 rem(4) rem(4)
          transition: .5s
          +media((padding: (320: 0 rem(24) 0, 992: rem(7) rem(40) rem(34))))
          .title
            font-style: normal
            font-weight: bold
            font-size: rem(14)
            line-height: rem(18)
            color: $black
            +media((padding-bottom: (320: rem(32), 992: rem(34))))
          .items
            // +media((padding: (320: rem(15) rem(24) rem(9), 768: rem(31) rem(30) rem(9))))
            .swiper
              &-container
                cursor: pointer
                margin: 0
                +media((padding-bottom: (320: rem(32), 992: rem(34))))
                &:hover
                  .swiper
                    &-scrollbar
                      &-drag
                        background: rgba(227, 7, 19, 0.5)
                  > .swiper-scrollbar
                    background: rgba(0, 0, 0, 0.1)
                .accordion__links-item, .slide
                  border: rem(1) solid #ECECEC
                  box-sizing: border-box
                  text-decoration: none
                  +media((padding: (320: rem(5), 768: rem(10))))
                  .content
                    &__img
                      svg
                        width: 100%
                        height: auto
                    &__info
                      display: flex
                      flex-direction: row
                      align-items: center
                      justify-content: center
                      font-style: normal
                      font-size: rem(12)
                      line-height: 1
                      font-weight: 500
                      &-size
                        color: $black
                      &-count
                        color: #999999
                        padding-left: rem(5)
                  .overlay
                    padding: rem(20)
                    height: 100%
                    width: 100%
                    position: absolute
                    top: 0
                    left: 0
                    text-align: center
                    pointer-events: none
                    background: rgba(227, 7, 19, 0.75)
                    color: #fff
                    transition: .5s
                    display: flex
                    flex-direction: column
                    justify-content: center
                    align-items: center
                    font-style: normal
                    font-weight: 500
                    font-size: rem(14)
                    line-height: rem(20)
                    opacity: 0
                    box-sizing: border-box
                  &:hover
                    .overlay
                      opacity: 1
                .swiper
                  &-scrollbar
                    height: rem(6)
                    bottom: 0
                    &-drag
                      border-radius: rem(12)
                      background: rgba(227, 7, 19, 0.2)
            .swiper-container-horizontal > .swiper-scrollbar
              background: rgba(0, 0, 0, 0.05)
              height: rem(6)
              width: 100%
              left: 0
</style>
